export default __webpack_public_path__ + "static/media/White_Cloud_large_2.0550caa2.jpg";